export default __webpack_public_path__ + "static/media/Contemporary.a1dba84b.jpg";